// extracted by mini-css-extract-plugin
export default {"root":"task_root__cAxTn","checkbox":"task_checkbox__aeIew"};